import React from "react";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";

export default function HelpFeedbackSection({ onOpen }) {
  return (
    <SettingsSection
      id="help-feedback"
      title="Help & Feedback"
      icon={<ChatBubbleLeftRightIcon className="h-5 w-5 text-primary" />}
    >
      <button
        onClick={onOpen}
        className="w-full flex items-center gap-3 p-4 rounded-lg border border-border-light bg-surface-elevated hover:bg-surface hover:border-border-strong transition-all duration-200 text-left group"
      >
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary flex items-center justify-center group-hover:bg-primary-100 transition-colors">
          <ChatBubbleLeftRightIcon className="h-5 w-5 text-text-inverse" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-text-primary">
            Help & Feedback
          </div>
          <div className="text-xs text-text-muted mt-0.5">
            Get support, report bugs, or suggest improvements
          </div>
        </div>
      </button>
    </SettingsSection>
  );
}
